import { colors } from "../../constants/colors";

const inputBackground = colors.blue_green[900];
const inputBackgroundHover = colors.blue_green[800];

export const styles = {
  container: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: `linear-gradient(90deg, ${colors.blue_green[600]} 10%, ${colors.prussian_blue[400]} 90%)`,
  },
  paper: {
    p: 4,
    width: "100%",
    maxWidth: 400,
    borderRadius: 2,
    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
    background: "white",
  },
  title: {
    fontSize: "2rem",
    fontWeight: "bold",
    textAlign: "center",
    color: colors.blue_green[900],
  },
  subtitle: {
    variant: "subtitle1",
    align: "center",
    color: "textSecondary",
    gutterBottom: true,
    textAlign: "center",
    marginLeft: "auto",
    marginRight: "auto",
  },
  tabs: {
    mb: 3,
    "& .MuiTab-root": {
      textTransform: "none",
      fontWeight: "bold",
    },
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },

  textField: {
    "& .MuiInputBase-root": {
      backgroundColor: inputBackground,
      padding: "8px 12px",
      "&:hover, &.Mui-focused": {
        backgroundColor: inputBackgroundHover,
      },
      "& .MuiInputBase-input": {
        backgroundColor: "transparent",
      },
    },
    mb: 2,
    "& .MuiFormHelperText-root": {
      color: "white",
      // color: colors.prussian_blue[500],
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "transparent",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "transparent",
    },
    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
      borderBottomColor: "transparent",
    },
    "& .MuiInputBase-input": {
      backgroundColor: "transparent",
      // Add these styles to override browser autocomplete
      "&:-webkit-autofill": {
        WebkitBoxShadow: "0 0 0 100px " + inputBackground + " inset",
        WebkitTextFillColor: "black",
        transition: "background-color 5000s ease-in-out 0s",
      },
      "&:-webkit-autofill:hover": {
        WebkitBoxShadow: "0 0 0 100px " + inputBackgroundHover + " inset",
      },
      "&:-webkit-autofill:focus": {
        WebkitBoxShadow: "0 0 0 100px " + inputBackgroundHover + " inset",
      },
    },
  },
  submitButton: {
    mt: 3,
    py: 1.5,
    textTransform: "none",
    fontSize: "1.1rem",
    background: `linear-gradient(90deg, ${colors.blue_green[600]} 10%, ${colors.prussian_blue[600]} 99%)`,
    "&:hover": {
      backgroundColor: colors.blue_green[300],
    },
  },
  errorAlert: {
    mb: 2,
  },
};
